import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceRedirect } from "../features/context";

export const Route = createFileRoute("/_app/")({ component: WorkspaceRedirect });
